import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  BRAND_DISPLAY_NAME,
  CONTACT_TYPE,
  MODAL_KEYS,
  PLACEHOLDER_EMAIL,
  PLAN_STATUS_KEY,
} from 'app-constants'
import { Alert } from 'components'
import { setModal } from 'slices/modal'
import { getFirstName } from 'utils'
import { useDashboard } from './hook'
import {
  Bills,
  BannersCarousel,
  DigitalServiceCarousel,
  PlanInfo,
  ServiceCards,
  DashboardCanceledContract,
  DashboardFaq,
} from './components'
import './style.scss'

export function Dashboard() {
  const [showContactAlert, setShowContactAlert] = useState(false)
  const [showReadjustmentAlert, setShowReadjustmentAlert] = useState(false)
  const [localAlerts, setLocalAlerts] = useState([])
  const { customer, selectedContract, contractDetails } = useDashboard()
  const isCanceledContract = selectedContract.contractStatus === PLAN_STATUS_KEY.ST_CONT_CANCELADO
  const dispatch = useDispatch()
  const {
    info: { contacts },
    alerts,
    readjustmentLink,
  } = useSelector(({ contract: { selected }, customer: { info }, alert }) => ({
    readjustmentLink: selected.readjustmentLink,
    info,
    alerts: alert.list,
  }))

  useEffect(() => {
    const isMissingConfirmedPhone = contacts
      .filter(({ contactType }) => contactType === CONTACT_TYPE.PHONE)
      .every(contact => !contact.confirmed)

    const isMissingConfirmedEmail = contacts
      .filter(({ contactType }) => contactType === CONTACT_TYPE.EMAIL)
      .every(contact => !contact.confirmed)

    const incompleteSignup =
      contacts.length === 0 || isMissingConfirmedEmail || isMissingConfirmedPhone

    const shouldChangeEmail = contacts.find(
      ({ contact, principal }) => contact.includes(PLACEHOLDER_EMAIL) && principal
    )

    setShowContactAlert(incompleteSignup)
    shouldChangeEmail && dispatch(setModal({ key: MODAL_KEYS.UPDATE_EMAIL }))
  }, [dispatch, contacts])

  useEffect(() => {
    setLocalAlerts(alerts)
  }, [alerts])

  useEffect(() => {
    setShowReadjustmentAlert(!!readjustmentLink)
  }, [readjustmentLink])

  function renderTitle() {
    const firstName = getFirstName(customer.name)
    return (
      <h1 className='title'>
        Olá <span className='name'>{firstName}</span>, você está na sua conta {BRAND_DISPLAY_NAME}
      </h1>
    )
  }

  function renderContactAlert() {
    return (
      <Alert
        className='alert'
        size='large'
        severity='info'
        title='Você ainda não completou seu cadastro.'
      />
    )
  }

  function renderReadjustmentAlert() {
    return (
      <Alert
        className='alert'
        size='large'
        severity='info'
        title='O seu contrato foi reajustado.'
      />
    )
  }

  function renderAlert() {
    return (
      <>
        {showContactAlert && renderContactAlert()}
        {showReadjustmentAlert && renderReadjustmentAlert()}
        {localAlerts.map(alert => (
          <Alert
            className='alert'
            key={alert.id}
            title={alert.title}
            severity={alert.severity}
            onClose={() => setLocalAlerts(prev => prev.filter(a => a.id !== alert.id))}
          />
        ))}
      </>
    )
  }

  function renderBills() {
    return <Bills selectedContract={selectedContract} contractId={selectedContract.id} />
  }

  function renderDigitalServices() {
    return (
      <section className='digital-services-container'>
        <DigitalServiceCarousel contract={contractDetails} />
        <BannersCarousel />
      </section>
    )
  }

  function renderContentByStatus() {
    if (isCanceledContract) {
      return (
        <section className='section'>
          <DashboardCanceledContract />
        </section>
      )
    }

    return (
      <>
        <section className='section'>
          <ServiceCards />
        </section>
        {renderDigitalServices()}
        <section className='section'>
          <PlanInfo />
        </section>
        <section className='section'>
          <DashboardFaq />
        </section>
      </>
    )
  }

  return (
    <div className='dashboard'>
      <section className='section'>{renderAlert()}</section>
      <section className='section'>{renderTitle()}</section>
      <section className='section'>{renderBills()}</section>
      {renderContentByStatus()}
    </div>
  )
}
